import OpponentPanel from './OpponentPanel';

export default OpponentPanel;